/**
 *
 * ES 评论接口改造
 *
 *
 */

import { getCookieItem } from "@/lib/commonService";

import { VISITOR_COOKIE_NAME } from "@/config/constConf";

import { PRODUCT_COMMENT_API, COMMET_PREVIEW_API } from "@/config/api";
import {
    HandleJavaOpencvFetch,
    HandleJavaReviewFetch,
    HandlePhpFetch,
} from "@/src/utils/fetch";
import { getEnv } from "@/src/utils/configUtils";

function getVistorId(): string {
    let cookieData: Record<string, any> | null;
    try {
        const cookiestr = getCookieItem(VISITOR_COOKIE_NAME);
        cookieData = cookiestr ? JSON.parse(cookiestr) : null;
        return cookieData?.visitor_id;
    } catch (e) {
        console.error("getVistorId", e);
        return "";
    }
}

export const getProductComment = (
    id: number,
    data: Record<string, any>,
    visitorId?: string,
    headers?: Record<string, any>,
) => {
    const visitor_id = visitorId || getVistorId();
    const type = 1;
    if (!getEnv("JAVA_REVIEW")) {
        console.log("=========================");
        console.log("ES API不存在");
        console.log("评论获取老接口");
        console.log("=========================");
        return HandleJavaOpencvFetch.get(
            PRODUCT_COMMENT_API + id,
            { visitor_id, type, ...data },
            headers,
        );
    }

    try {
        return HandleJavaReviewFetch.get(
            "/front/comment/all/" + id,
            { visitor_id, type, ...data },
            headers,
        );
    } catch (e) {
        console.log("=========================");
        console.log("ES 接口报错：", e);
        console.log("评论获取老接口");
        console.log("=========================");

        return HandleJavaOpencvFetch.get(PRODUCT_COMMENT_API + id, {
            visitor_id,
            type,
            ...data,
        });
    }
};

export const getProductPreviewCommentOrQuestion = async (
    id: number,
    visitorId?: string,
    cookie?: string,
    headers?: Record<string, any>,
) => {
    const visitor_id = visitorId ?? getVistorId();
    if (
        !(typeof window !== "undefined"
            ? getEnv("JAVA_REVIEW")
            : process.env.JAVA_REVIEW_URL)
    ) {
        console.log("=========================");
        console.log("ES API不存在");
        console.log("评论获取老接口");
        console.log("=========================");
        return HandlePhpFetch.get(
            COMMET_PREVIEW_API + id,
            {
                visitor_id,
                cookie,
            },
            headers,
        );
    }
    try {
        return handleReviewData(
            await getIntlAndLocalReview(id, visitor_id, headers),
        );
    } catch (error) {
        console.log("=========================");
        console.log("ES 接口报错：", error);
        console.log("评论获取老接口");
        console.log("=========================");

        return HandlePhpFetch.get(
            COMMET_PREVIEW_API + id,
            {
                visitor_id,
                cookie,
            },
            headers,
        );
    }
};

// 获取国际和本地评论
export const getIntlAndLocalReview = async (
    id: number,
    visitor_id = "",
    headers?: Record<string, any>,
) => {
    const promiseArr = [];
    // 数量的统计
    const countUrl = "front/comment/count/" + id;
    // 概述
    const summarizeUrl = "front/comment/" + id;
    const params = { visitor_id };
    promiseArr.push(HandleJavaReviewFetch.get(countUrl, params, { headers }));
    // 本地评论
    promiseArr.push(
        HandleJavaReviewFetch.get(
            summarizeUrl,
            { ...params, statusInterNational: 0 },
            { headers },
        ),
    );
    // 国际评论
    promiseArr.push(
        HandleJavaReviewFetch.get(
            summarizeUrl,
            { ...params, statusInterNational: 1 },
            { headers },
        ),
    );

    return await Promise.all(promiseArr);
};

const handleReviewData = (data: any) => {
    if (data.length !== 3) {
        return data[0];
    }
    const [count, localReview, intlReview] = data;
    if (localReview.reviews_comment.length === 0) {
        for (let i = 0; i < intlReview.reviews_comment.length; i++) {
            intlReview.reviews_comment[i].intl = true;
        }
    }
    return {
        reviews_ask: localReview.reviews_ask,
        reviews_comment:
            localReview.reviews_comment.length > 0
                ? localReview.reviews_comment
                : intlReview.reviews_comment,
        reviews_ask_tag: localReview.reviews_ask_tag,
        tags: localReview.tags,
        reviews_comment_tag: localReview.reviews_comment_tag,
        reviews_comment_number: localReview.reviews_comment_number,
        reviews_ask_number: localReview.reviews_ask_number,
        reviews_all: count.reviews_all,
        reviews_internal: count.reviews_internal,
        reviews_local: count.reviews_local,
        start: mergeObjects(localReview.start, intlReview.start),
        intlStart: intlReview.start,
        localStart: localReview.start,
    };
};

const mergeObjects = (
    o1: { [key: string]: number },
    o2: { [key: string]: number },
) => {
    const result: { [key: string]: number } = {};
    for (const key in o1) {
        result[key] = (o1[key] || 0) + (o2[key] || 0);
    }
    return result;
};
